export default "__VITE_ASSET__gJZwnQaT__"